<div class="integracao" [class.integracao--com-conteudo]="integracaoSelecionada()">
  <aside class="integracao__lateral">
    <app-button-padrao
      label="Adicionar Integração"
      backgroundColor="var(--primary)"
      color="white"
      width="100%"
      height="36px"
      fontSize="var(--title-primary-font-12-14)"
      (buttonClick)="adicionarIntegracao()">
    </app-button-padrao>

    <div class="integracao__lista"
      role="tablist"
      aria-label="Integrações do grupo"
      (scroll)="aoRolarLista($event)">
      @if (carregando()) {
        @for (item of [1, 2, 3]; track item) {
          <div class="integracao__skeleton"></div>
        }
      } @else {
        @for (integracao of integracoes(); track integracao.chave) {
          <div class="integracao__item cursor-pointer"
            [class.integracao__item--selecionado]="integracaoSelecionada()?.chave === integracao.chave"
            role="tab"
            tabindex="0"
            [attr.aria-selected]="integracaoSelecionada()?.chave === integracao.chave"
            (click)="selecionarIntegracao(integracao)"
            (keydown.enter)="selecionarIntegracao(integracao)">
            <div class="integracao__item-textos">
              <span class="font-12 weight-600 ellipse">
                {{ integracao.nome?.trim() || 'Nova Integração' }}
              </span>
              <span class="integracao__tipo">
                Integração {{ integracao.personalizada ? 'Personalizada' : 'Padrão' }}
              </span>
            </div>
            <img
              class="integracao__excluir cursor-pointer"
              src="./assets/icones/delete-forever.svg"
              alt="Inativar integração"
              matTooltip="Inativar integração"
              role="button"
              tabindex="0"
              (click)="excluir(integracao, $event)"
              (keydown.enter)="excluir(integracao, $event)">
          </div>
        } @empty {
          <div class="integracao__vazio">
            <span class="font-12 weight-600">Nenhuma integração cadastrada</span>
            <span class="font-11">Adicione a primeira integração do grupo.</span>
          </div>
        }

        @if (carregandoMais()) {
          <div class="integracao__carregando-mais">Carregando...</div>
        }
      }
    </div>
  </aside>

  @if (integracaoSelecionada(); as selecionada) {
    <section
      class="integracao__conteudo"
      [class.integracao__conteudo--sem-payload]="selecionada.personalizada">
      <div class="integracao__configuracoes">
        <div class="integracao__titulo-secao">Configurações da Integração</div>

        <app-form-field
          label="Nome da integração"
          heightFormField="35px"
          widthFormField="100%"
          placeholder="Digite"
          [value]="selecionada.nome"
          (changeValue)="atualizarCampo('nome', $event)">
        </app-form-field>

        <app-slide-toggle-padrao
          #toggleTipo
          labelTrue="Padrão"
          labelFalse="Personalizado"
          [valor]="!selecionada.personalizada"
          (changeValue)="atualizarTipo($event)">
        </app-slide-toggle-padrao>

        <app-form-field
          label="URL"
          heightFormField="35px"
          widthFormField="100%"
          placeholder="https://"
          [value]="selecionada.url"
          (changeValue)="atualizarCampo('url', $event)">
        </app-form-field>

        <app-form-field
          label="Token"
          heightFormField="35px"
          widthFormField="100%"
          placeholder="Digite"
          [isSenha]="true"
          [value]="selecionada.token"
          (changeValue)="atualizarCampo('token', $event)">
        </app-form-field>

        <div class="integracao__acoes">
          <app-button-padrao
            backgroundColor="var(--verde-padrao)"
            color="white"
            [label]="salvando() ? 'Salvando...' : 'Salvar'"
            width="100%"
            height="36px"
            fontSize="var(--title-primary-font-12-14)"
            [disabled]="salvando()"
            (buttonClick)="salvar()">
          </app-button-padrao>
          <app-button-padrao
            label="Cancelar"
            backgroundColor="white"
            color="var(--vermelho-padrao)"
            borderColor="var(--vermelho-padrao)"
            borderStyle="solid"
            borderWidth="1px"
            width="100%"
            height="36px"
            fontSize="var(--title-primary-font-12-14)"
            [disabled]="salvando()"
            (buttonClick)="cancelar()">
          </app-button-padrao>
        </div>
      </div>

      @if (!selecionada.personalizada) {
        <div class="integracao__payload">
          <div class="integracao__titulo-secao">Payload da Integração</div>

          <div class="integracao__montagem-payload">
            <div class="integracao__editor-payload">
              <app-json-editor
                #editorPayload
                label="Payload"
                altura="320px"
                [autoAjustarAltura]="true"
                [isEditavel]="true"
                [value]="selecionada.payload"
                (changeValue)="atualizarCampo('payload', $event)"
                (validoChange)="payloadValido.set($event)">
              </app-json-editor>
            </div>

            <div class="integracao__controles-variaveis">
              <app-button-padrao
                label="Adicionar variável"
                backgroundColor="var(--primary)"
                color="white"
                width="100%"
                height="34px"
                fontSize="var(--text-primary-font-10-12)"
                (buttonClick)="adicionarVariavel()">
              </app-button-padrao>

              @if (selecionada.variaveis.length > 0) {
                <span class="label">Variáveis</span>
                <div class="integracao__variaveis">
                  @for (variavel of selecionada.variaveis; track variavel.ordem) {
                    <div class="integracao__variavel">
                      <span class="integracao__marcador">
                        {{ montarMarcador(variavel.ordem) }}
                      </span>
                      <app-select-one
                        class="integracao__select"
                        widthFormField="100%"
                        heightFormField="35px"
                        placeholder="Selecione"
                        campo="nome"
                        [listaInput]="opcoesVariaveis"
                        [itemSelecionado]="obterOpcao(variavel.campo)"
                        (selecionarItem)="selecionarVariavel(variavel.ordem, $event)">
                      </app-select-one>
                      <img
                        class="integracao__remover-variavel cursor-pointer"
                        src="./assets/icones/delete-forever.svg"
                        alt="Remover variável"
                        matTooltip="Remover variável"
                        role="button"
                        tabindex="0"
                        (click)="removerVariavel(variavel.ordem)"
                        (keydown.enter)="removerVariavel(variavel.ordem)">
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    </section>
  }
</div>
